import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { useMemo } from 'react';
import { validateDate } from './validateDate';
import { jsx as _jsx } from "react/jsx-runtime";
const ResetDate = ({
  limitResetDate,
  upgradeKey
}) => {
  const validatedLimitResetDate = useMemo(() => limitResetDate ? validateDate(limitResetDate, upgradeKey) : limitResetDate, [limitResetDate, upgradeKey]);
  if (!validatedLimitResetDate) {
    return null;
  }
  const FormattedDate = () => /*#__PURE__*/_jsx(FormattedDateTime, {
    value: validatedLimitResetDate,
    format: "short-date"
  });
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "usageLimitCounter.defaultCopy.tooltipLimitReset_jsx",
    elements: {
      FormattedDate
    }
  });
};
export default ResetDate;